import { MobilePush } from '@iotv/iotv-v3-types'
import { PossibleBusinessObject } from '../types'
import { UserAttributeDefs } from '../types/ModelTypes'
import { ModelCommon } from './ModelCommon'
import { MDevice } from '../ModelClassInterfaces/MobileDevice'

const typeName = 'MobileDevice'

export class MobileDevice extends ModelCommon implements MDevice {
  constructor(ob: PossibleBusinessObject) {
    super(typeName, { ...ob, type: ob.type ?? typeName })
    this.mobilePushPlatform = ob.mobilePushPlatform
    this.deviceToken = ob.deviceToken
    this.platformEndpointArn = ob.platformEndpointArn
    this.isProduction = !!ob.isProduction
  }

  mobilePushPlatform: MobilePush
  deviceToken: null | string
  platformEndpointArn: null | string
  isProduction: boolean

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
    }
  }
}
